function getCredentialsFromLocalStorage() {
  return JSON.parse(localStorage.getItem('credentials') as string) ?? {};
}

export default getCredentialsFromLocalStorage;
